var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfit1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 78.75C27.0173 78.7533 24.1577 79.9396 22.0487 82.0487C19.9396 84.1577 18.7533 87.0173 18.75 90V101.25C18.75 104.234 19.9353 107.095 22.045 109.205C24.1548 111.315 27.0163 112.5 30 112.5C32.9837 112.5 35.8452 111.315 37.955 109.205C40.0647 107.095 41.25 104.234 41.25 101.25V90C41.2467 87.0173 40.0604 84.1577 37.9513 82.0487C35.8423 79.9396 32.9827 78.7533 30 78.75Z",
    fill: "url(#paint0_linear_20_197)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 60C57.0173 60.0033 54.1577 61.1896 52.0487 63.2987C49.9396 65.4077 48.7533 68.2673 48.75 71.25V101.25C48.75 104.234 49.9353 107.095 52.045 109.205C54.1548 111.315 57.0163 112.5 60 112.5C62.9837 112.5 65.8452 111.315 67.955 109.205C70.0647 107.095 71.25 104.234 71.25 101.25V71.25C71.2467 68.2673 70.0604 65.4077 67.9513 63.2987C65.8423 61.1896 62.9827 60.0033 60 60Z",
    fill: "url(#paint1_linear_20_197)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90 41.25C87.0173 41.2533 84.1577 42.4396 82.0487 44.5487C79.9396 46.6577 78.7533 49.5173 78.75 52.5V101.25C78.75 104.234 79.9353 107.095 82.045 109.205C84.1548 111.315 87.0163 112.5 90 112.5C92.9837 112.5 95.8452 111.315 97.955 109.205C100.065 107.095 101.25 104.234 101.25 101.25V52.5C101.247 49.5173 100.06 46.6577 97.9513 44.5487C95.8423 42.4396 92.9827 41.2533 90 41.25Z",
    fill: "url(#paint2_linear_20_197)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5 11.25H82.5C81.5054 11.25 80.5516 11.6451 79.8484 12.3483C79.1451 13.0516 78.75 14.0054 78.75 15C78.75 15.9946 79.1451 16.9484 79.8484 17.6516C80.5516 18.3549 81.5054 18.75 82.5 18.75H88.7558C80.4098 27.2754 71.3168 35.0359 61.5859 41.9385C47.9127 51.5986 33.0788 59.5006 17.4334 65.4585C16.5039 65.8125 15.7531 66.5213 15.3462 67.4288C14.9393 68.3364 14.9096 69.3684 15.2636 70.2979C15.6176 71.2273 16.3264 71.9781 17.2339 72.385C18.1415 72.7919 19.1735 72.8216 20.103 72.4676C36.3369 66.2865 51.7282 58.0867 65.9141 48.0615C75.8727 41.0018 85.1876 33.0754 93.75 24.375V30C93.75 30.9946 94.1451 31.9484 94.8484 32.6516C95.5516 33.3549 96.5054 33.75 97.5 33.75C98.4946 33.75 99.4484 33.3549 100.152 32.6516C100.855 31.9484 101.25 30.9946 101.25 30V15C101.218 14.0155 100.813 13.0801 100.116 12.3836C99.42 11.6871 98.4845 11.2818 97.5 11.25Z",
    fill: "url(#paint3_linear_20_197)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_197",
    x1: 18.75,
    y1: 95.625,
    x2: 43.1014,
    y2: 95.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30BDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5189E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20_197",
    x1: 48.75,
    y1: 86.25,
    x2: 73.1014,
    y2: 86.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30BDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5189E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_20_197",
    x1: 78.75,
    y1: 76.875,
    x2: 103.101,
    y2: 76.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30BDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5189E1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_20_197",
    x1: 15.018,
    y1: 41.9816,
    x2: 108.346,
    y2: 41.9816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30BDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5189E1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfit1);
export default __webpack_public_path__ + "static/media/profit1.6cf10868d60e9afc63ab6784c3a8b87b.svg";
export { ForwardRef as ReactComponent };